import { get, post, put, Delete } from "@/services/api";

// GET /myapi/dashboards
export function fetchDashboards() {
  return get("myapi/dashboards").then((res) => res.data);
}

// GET /myapi/dashboards/{id}
export function fetchDashboardById(id) {
  return get(`myapi/dashboards/${id}`).then((res) => res.data);
}

// POST /myapi/dashboards
export function createDashboard({ title, companyId }) {
  return post("myapi/dashboards", { name: title, companyId }).then((res) => res.data);
}

// PUT /myapi/dashboards/{id}
export function updateDashboard(id, { title }) {
  return put(`myapi/dashboards/${id}`, { name: title }).then((res) => res.data);
}

// PUT /myapi/dashboards/{id}/widgets
export function updateDashboardWidgets(id, widgets) {
  return put(`myapi/dashboards/${id}/widgets`, { widgets }).then((res) => res.data);
}

// DELETE /myapi/dashboards/{id}
export function deleteDashboard(id) {
  return Delete(`myapi/dashboards/${id}`);
}
